export enum TankConstants {
    GET_TANKS_SUCCESS = "GET_TANKS_SUCCESS",
    REFRESH_TANK = "REFRESH_TANK",
    ERROR = "ERROR",
  };